<template>
  <div class="modal_wrapper">
    <div
      id="keywords_modal"
      class="modal_window white_box keywords_modal"
    >
      <div class="video_wrapper">
        <div class="heading_wrapper">
          <h3 class="heading">
            Average ranking over time
          </h3>

          <div>
            <button
              class="btn btn-sm btn-default"
              @click="toggleAnnotations"
            >
              <span
                v-if="!algorithmUpdatesVisible"
                class="text-primary"
              >
                <i class="fad fa-eye" /> Show Algorithm Updates
              </span>
              <span
                v-else
                class="text-primary"
              >
                <i class="fad fa-eye-slash" /> Hide Algorithm Updates
              </span>
            </button>

            <button
              class="close_modal close_btn"
              @click="closeModal()"
            >
              <svg
                fill="none"
                height="32"
                viewBox="0 0 32 32"
                width="32"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M25 7L7 25"
                  stroke="#040707"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
                <path
                  d="M25 25L7 7"
                  stroke="#040707"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                />
              </svg>
            </button>
          </div>
        </div>
        <div v-if="!loading && !error">
          <apexchart
            v-if="!loading && !error"
            :options="options"
            :series="series"
            height="300"
            type="line"
            @zoomed="axisChanged"
            @scrolled="axisChanged"
          />

          <div
            v-if="algorithmUpdatesVisible"
            class="row algorithm-updates"
          >
            <div
              v-for="(algorithmUpdate, index) in algorithmUpdatesForChart"
              :key="index"
              class="col-12 col-lg-6 d-flex"
            >
              <div class="card flex-grow-1">
                <div class="card-body">
                  <h4 class="text-info xs-mb-0">
                    {{ algorithmUpdate.title }}
                  </h4>
                  <p class="text-success xs-mb-0">
                    Date Updated: {{ moment(algorithmUpdate.date).format('DD/MM/YYYY') }}
                  </p>
                  <p class="xs-mb-0">
                    {{ algorithmUpdate.description }}
                  </p>
                </div>
              </div>
            </div>

            <div
              v-if="algorithmUpdatesForChart.length === 0"
              class="col-12"
            >
              <p class="text-center mt-4 font-size-16">
                There are no algorithm updates to show within the selected date range.
              </p>
            </div>
          </div>
        </div>
        <div
          v-if="loading"
          class="loading_placeholder"
        >
          <i class="fa fa-btn fa-spinner fa-spin" /> Loading Data
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';

export default {
  data() {
    return {
      moment: null,
      startDate: null,
      endDate: null,
      loading: true,
      error: '',
      series: [{
        name: "Average Ranking",
        data: []
      }],
      options: {
        chart: {
          width: '100%',
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          show: false
        },
        noData: {
          text: 'No Data',
          style: {
            fontSize: '25px',
          }
        },
        colors: ['#0c9bef', '#969696'],
        xaxis: {
          categories: [],
          type: 'datetime',
        },
        yaxis: [{
          reversed: true,
          min: 1,
          max: 100,
          forceNiceScale: true
        }],
      },
      algorithmUpdatesVisible: false,
      algorithmUpdates: [],
    }
  },
  computed: {
    algorithmUpdatesForChart() {
      return this.algorithmUpdates.filter(update => {
        if (!this.startDate || !this.endDate) {
          return true
        }

        return this.startDate <= update.date && this.endDate >= update.date
      })
    }
  },
  created: function () {
    this.moment = moment
  },
  async mounted() {
    await this.getAverageRanking()
  },
  methods: {
    async getAverageRanking() {
      try {
        const { data } = await axios.get('ajax/keywords/average-ranking-chart')

        this.algorithmUpdates = data.algorithmUpdates

        this.series[0].data = data.average.data;
        this.options = {
          ...this.options,
          xaxis: {
            ...this.options.xaxis,
            categories: data.average.labels,
          },
        }
        this.loading = false
      } catch (e) {
        this.error = true
        this.loading = false
      }
    },
    toggleAnnotations() {
      const annotations = this.algorithmUpdates.map(update => ({
        x: new Date(update.date).getTime(),
        strokeDashArray: 0,
        borderColor: update.color,
        label: {
          borderColor: update.color,
          style: {
            color: update.text_color,
            background: update.color,
          },
          text: update.title,
        },
      }))

      this.options = {
        ...this.options,
        annotations: {
          xaxis: !this.algorithmUpdatesVisible ? annotations : [],
        },
      }
      this.algorithmUpdatesVisible = !this.algorithmUpdatesVisible
    },
    axisChanged(_, {xaxis}) {
      this.startDate = xaxis.min ? this.moment(xaxis.min).format('YYYY-MM-DD') : null
      this.endDate = xaxis.max ? this.moment(xaxis.max).format('YYYY-MM-DD') : null
    },
    closeModal() {
      this.$parent.showAverageModal = false
    }
  },
}
</script>

<style scoped>
.modal_wrapper {
  z-index: 100;
  position: fixed;
  display: flex;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  padding: 2vh 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.2);
}

.modal_wrapper::-webkit-scrollbar {
  width: 0;
}

.modal_window {
  position: relative;
  margin: auto;
  width: 1000px;
  z-index: 100;
  -webkit-box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  box-shadow: 0px 10px 30px rgba(4, 7, 7, 0.2);
  border-radius: .75rem;
}

.close_btn {
  height: auto;
}

.heading_wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.heading {
  font-weight: 700;
  line-height: 1.42;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 1.5rem;
}

.video_wrapper .btn {
  height: 42px;
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
}

.loading_placeholder {
  width: 100%;
  height: 315px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.loading_placeholder i {
  margin-right: 5px;
}

.algorithm-updates {
  max-height: 30vh;
  min-height: 150px;
  overflow: scroll;
  padding-top: 10px;
}

</style>
